module.exports = __webpack_public_path__ + "bin/c9d2af01385e3a645e4b3a3dd037f0e4.svg";